<app-mb-card class="services-card">
  <header>
    <h3>Productos y aplicaciones habilitados para la compañía</h3>
  </header>
  <footer [formGroup]="servicesCompanyForm">
    <p>Productos habilitados para la compañía</p>
    @if (showProductsForm) {
      <div [formGroup]="productsForm">
        @for (product of products; track product) {
          <app-mb-field [title]="product.mproductName" inline>
            <input type="checkbox" [formControlName]="product.mproductCode" (change)="updateProduct(product)">
          </app-mb-field>
        }
      </div>
    }
    <p>Aplicaciones habilitadas para la compañía</p>
    @if (showApplicationsForm) {
      <div [formGroup]="applicationsForm">
        @for (application of applications | filterApplicationsByProducts: getActiveProducts(); track application) {
          <app-mb-field [title]="application.applicationName" inline>
            <input type="checkbox" [formControlName]="application.applicationName" (change)="updateApplication(application)">
          </app-mb-field>
        }
      </div>
    }
  </footer>
</app-mb-card>